const ALLOWED_EVENTS = new Set([
  'store_join_opened',
  'store_join_auth_method_selected',
  'store_join_challenge_sent',
  'store_join_verified',
  'store_join_consent_viewed',
  'store_join_confirmed',
  'store_join_deferred',
  'store_join_completed',
  'store_join_failed'
])
const ALLOWED_FIELDS = new Set(['phase', 'channel', 'result', 'error_code', 'contract_version'])
const SENSITIVE_KEY = /(authorization|onboarding.context|idempotency|token|code|jwt|identifier|email|phone|fragment|request.?body|customer.?id|public.?id|cafe|store|first.?name|last.?name|address)/i
const UUID_PATTERN = /\b[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/gi
const COUNTER_PATH_PATTERN = /(\/join\/counter\/|\/counter-qr\/|\/counter-contexts\/)[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/gi

export function trackOnboardingEvent(name, properties = {}) {
  if (!ALLOWED_EVENTS.has(name)) return false
  const sanitized = { event: name }
  for (const [key, value] of Object.entries(properties)) {
    if (!ALLOWED_FIELDS.has(key)) continue
    if (!['string', 'number', 'boolean'].includes(typeof value)) continue
    sanitized[key] = value
  }

  window.dispatchEvent(new CustomEvent('lazygrid:onboarding', { detail: sanitized }))
  return true
}

export function sanitizeUrl(value) {
  if (!value || typeof value !== 'string') return value
  try {
    const url = new URL(value, window.location.origin)
    url.pathname = url.pathname.replace(COUNTER_PATH_PATTERN, (match, prefix) => `${prefix}:public_id`)
    return `${url.origin}${url.pathname}`
  } catch {
    return sanitizeString(value.split(/[?#]/, 1)[0])
  }
}

function sanitizeString(value) {
  if (typeof value !== 'string') return value
  return value
    .replace(COUNTER_PATH_PATTERN, (match, prefix) => `${prefix}:public_id`)
    .replace(UUID_PATTERN, '[Filtered]')
    .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[Filtered]')
    .replace(/\bBearer\s+[^\s,;]+/gi, 'Bearer [Filtered]')
}

function redactObject(value, depth = 0) {
  if (typeof value === 'string') return sanitizeString(value)
  if (!value || typeof value !== 'object' || depth > 5) return value
  if (Array.isArray(value)) return value.map((entry) => redactObject(entry, depth + 1))

  const copy = {}
  for (const [key, entry] of Object.entries(value)) {
    if (SENSITIVE_KEY.test(key)) copy[key] = '[Filtered]'
    else if (key === 'url') copy[key] = sanitizeUrl(entry)
    else copy[key] = redactObject(entry, depth + 1)
  }
  return copy
}

export function sanitizeSentryEvent(event) {
  const sanitized = redactObject(event)
  if (sanitized.request) {
    sanitized.request.url = sanitizeUrl(sanitized.request.url)
    delete sanitized.request.data
  }
  return sanitized
}

export function sanitizeSentryBreadcrumb(breadcrumb) {
  const sanitized = redactObject(breadcrumb)
  if (sanitized.data?.url) sanitized.data.url = sanitizeUrl(sanitized.data.url)
  if (sanitized.data) {
    delete sanitized.data.request_body
    delete sanitized.data.response_body
  }
  return sanitized
}
